import React from 'react';
import './PaymentStatusBadge.css';

const PaymentStatusBadge = ({ status, type = 'employer' }) => {
  const getStatusConfig = () => {
    if (type === 'employer') {
      switch (status) {
        case 'pending_employer_payment':
          return {
            label: 'Pending Payment',
            className: 'payment-status-badge--pending',
            icon: '⏳'
          };
        case 'employer_paid':
          return {
            label: 'Paid',
            className: 'payment-status-badge--paid',
            icon: '✓'
          };
        case 'failed':
          return {
            label: 'Failed',
            className: 'payment-status-badge--failed',
            icon: '✗'
          };
        default:
          return {
            label: status || 'Unknown',
            className: 'payment-status-badge--unknown',
            icon: '?'
          };
      }
    } else {
      // Employee payout status
      switch (status) {
        case 'pending_employee_payout':
          return {
            label: 'Pending Payout',
            className: 'payment-status-badge--pending',
            icon: '⏳'
          };
        case 'employee_paid':
          return {
            label: 'Paid',
            className: 'payment-status-badge--paid',
            icon: '✓'
          };
        case 'failed':
          return {
            label: 'Failed',
            className: 'payment-status-badge--failed',
            icon: '✗'
          };
        default:
          return {
            label: status || 'Unknown',
            className: 'payment-status-badge--unknown',
            icon: '?'
          };
      }
    }
  };

  const config = getStatusConfig();

  return (
    <span className={`payment-status-badge ${config.className}`}>
      <span className="payment-status-badge__icon">{config.icon}</span>
      <span className="payment-status-badge__label">{config.label}</span>
    </span>
  );
};

export default PaymentStatusBadge;






